// extracted by mini-css-extract-plugin
export var blue = "_3i-g";
export var brand = "_3i-c";
export var darkGrey = "_3i-f";
export var disabled = "_3i-6";
export var disabledSubtle = "_3i-7";
export var error = "_3i-8";
export var green = "_3i-h";
export var grey = "_3i-e";
export var icon = "_3i-0";
export var inherit = "_3i-b";
export var lightGrey = "_3i-d";
export var orange = "_3i-j";
export var pink = "_3i-l";
export var primary = "_3i-1";
export var purple = "_3i-m";
export var quaternary = "_3i-4";
export var quinary = "_3i-5";
export var red = "_3i-k";
export var secondary = "_3i-2";
export var success = "_3i-a";
export var tertiary = "_3i-3";
export var warning = "_3i-9";
export var white = "_3i-n";
export var yellow = "_3i-i";